import { writable } from "svelte/store";
import { UserModel } from "./models/UserModel";
class LogInOutStore {
    constructor() {
        this.token = writable("");
        this.isToken = writable(false);
        this.user = writable({ username: "", role: "" });
    }
}
class UserStore {
    constructor() {
        this.selectedUser = writable(new UserModel());
        this.isSelectUser = writable(false);
    }
}
// const createWritableStore = (key, startValue) => {
//     const { subscribe, set } = writable(startValue);
//     return {
//       subscribe,
//       set,
//       useLocalStorage: () => {
//         const json = localStorage.getItem(key);
//         if (json) {
//           set(JSON.parse(json));
//         }
//         subscribe(current => {
//           localStorage.setItem(key, JSON.stringify(current));
//         });
//       }
//     };
//   }
// export const username = createWritableStore('username', "");
// export const username: Writable<string> = writable(localStorage.getItem("username") || "");
// username.subscribe(val => localStorage.setItem("username", val));
// export const role: Writable<string> = writable(localStorage.getItem("role") || "");
// role.subscribe(val => localStorage.setItem("role", val));
// export const role = createWritableStore('role', "");
export const logInOut = new LogInOutStore();
export const tenants = writable([{ id: "", name: "", description: "" }]);
export const selectedTenant = writable({ id: "", name: "", description: "" });
export const isSelectedTenant = writable(false);
function createSelectedBuilding() {
    const { subscribe, set, update } = writable({
        id: "",
        name: "",
        openHours: [],
        status: "",
        maxOccupancy: null,
        currentOccupancy: null
    });
    return {
        subscribe,
        change: (s) => {
            return update(u => u = s);
        },
        reset: () => {
            return update(u => u = {
                id: "",
                name: "",
                openHours: [],
                status: "",
                maxOccupancy: null,
                currentOccupancy: null
            });
        }
    };
}
export const selectedBuilding = createSelectedBuilding();
// export const selectedBuilding: Writable<Building> = writable({
//     id:"", 
//     name:"", 
//     openHours: [], 
//     status: "",
//     maxOccupancy: null,
//     currentOccupancy: null
// });
export const gates = writable([{ id: "", name: "", type: "", status: "", policies: [] }]);
export const userStore = new UserStore();
